import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Col, Row} from "reactstrap";
import {Select} from "../form/fields/Select";
import {api} from "../../api";

export class FederalConstituencyFormData {
    @observable code = '';
    @observable name = '';
    @observable state_id: number|null = null;
    @observable is_active = true;
    @observable local_government_areas = [];
}

export class FederalConstituencyForm extends CrudForm {
    modelName = 'FederalConstituency';

    renderFields() {
        return (
            <>
                <Field
                    label="Code"
                    name="code"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="State"
                    name="state_id"
                    component={Select}
                    required={true}
                    loadOptions={api.state.getListAction}
                    store={this.formStore}
                    onChange={() => {
                        this.formStore.setValue('local_government_areas', []);
                    }}
                />

                <Field
                    key={this.formStore.getValue('state_id')}
                    label="Local Government Areas"
                    name="local_government_areas"
                    component={Select}
                    multi={true}
                    required={true}
                    valueObject={true}
                    loadOptions={() => {
                        return api.localGovernmentArea.getListAction({
                            filters: {
                                state_id: this.formStore.getValue('state_id')
                            }
                        });
                    }}
                    store={this.formStore}
                />

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                />
            </>
        );
    }
}

export class FederalConstituencyFilterForm {
    @observable name = '';
}

export class FederalConstituencyList extends CrudList {
    modelName = 'FederalConstituency';

    defaultSortColumn = 'state.name';
    defaultSortDirection = 'asc';

    colums() {
        return [
            {
                name: "state.code",
                label: "State Code",
                sort: true,
            },
            {
                name: "state.name",
                label: "State",
                sort: true,
            },
            {
                name: "name",
                label: "Fed Cons.",
                sort: true,
            },
            {
                name: "code",
                label: "Fed. Cons. Code",
                sort: true,
            },
        ];
    }

    idColumn() {
        return '';
    }

    renderFilters() {
        return (
            <Row className="form-row">
                <Col md={3} lg={4} xl={3}>
                    <Field
                        placeholder="Name"
                        name="name"
                        component={Input}
                        store={this.filterFormStore}
                    />
                </Col>

                <Col md={3} lg={4} xl={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
        );
    }
}

export class FederalConstituencyPage extends CrudPage {
    modelName = 'FederalConstituency';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/FederalConstituencyPage.tsx